import WalletInput from "./wallet-input";

import { useWallet, WalletType } from "@/providers/wallet";
import CopyButton from "../copy/copy-button";
import ActiveWalletBtn from "./active-wallet-btn";
import DollarSignBtn from "./dollar-sign-btn";
import KeyShowButton from "./key-show-button";
import DeleteWalletButton from "./delete-wallet-button";

const EthereumWalletControls = () => {
  const { ethereumAddresses, currentWallet, setWallet, onWalletDelete } =
    useWallet();

  return (
    <div className="flex flex-col gap-[0.3125rem]">
      {ethereumAddresses.map((ethWallet) => (
        <div
          key={ethWallet.address}
          className="flex flex-row items-center gap-[0.3125rem]"
        >
          <div className="text-xs text-white w-[7rem]">
            Wallet {currentWallet.address === ethWallet.address && `(Active)`}:
          </div>
          <WalletInput
            key={ethWallet.address}
            address={ethWallet.address}
            walletType={WalletType.ETH}
          />
          <ActiveWalletBtn
            onClick={() => setWallet(ethWallet)}
            active={currentWallet.address === ethWallet.address}
          />
          <CopyButton
            value={ethWallet.address}
            className="h-[1.375rem] w-[1.375rem]"
            iconClassName="w-[0.65rem] h-[0.65rem]"
          />
          <KeyShowButton onClick={() => {}} />
          <DollarSignBtn onClick={() => {}} />
          <DeleteWalletButton
            onClick={() => onWalletDelete(ethWallet.address, WalletType.ETH)}
          />
        </div>
      ))}
    </div>
  );
};

export default EthereumWalletControls;
